<template>
  <div class="shadow overflow-hidden">
    <div>
      <dl>
        <div
          class="bg-gray-50 dark:bg-gray-800 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
        >
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t("violation.tr_date") }}
          </dt>
          <dd
            class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2"
          >
            {{ violation.transaction_date }}
          </dd>
        </div>

        <div
          class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
        >
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t("punishment.violation") }}
          </dt>
          <dd
            class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2"
          >
            {{ violation.violation_description }}
          </dd>
        </div>

        <div
          class="bg-gray-50 dark:bg-gray-800 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
        >
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t("punishment.punishment") }}
          </dt>
          <dd
            class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2"
          >
            {{ violation.punishment_description }}
          </dd>
        </div>

        <div
          class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
        >
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t("violation.remarks") }}
          </dt>
          <dd
            class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2"
          >
            {{ violation.remarks }}
          </dd>
        </div>

        <div
          class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
        >
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t("violation.proposed_by") }}
          </dt>
          <dd
            class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2"
          >
            {{ violation.proposed }}
          </dd>
        </div>

        <div
          class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
        >
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t("violation.hr_pic1") }}
          </dt>
          <dd
            class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2"
          >
            {{ violation.hr1 }}
          </dd>
        </div>

        <div
          class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
        >
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t("violation.hr_pic2") }}
          </dt>
          <dd
            class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2"
          >
            {{ violation.hr2 }}
          </dd>
        </div>

        <div
          class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
        >
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t("violation.witnees1") }}
          </dt>
          <dd
            class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2"
          >
            {{ violation.witnes1 }}
          </dd>
        </div>

        <div
          class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
        >
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t("violation.witnees2") }}
          </dt>
          <dd
            class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2"
          >
            {{ violation.witnes2 }}
          </dd>
        </div>
      </dl>
    </div>
    <!-- <main-section>
      <violation-consequencies
        :violationId="violation.id"
      />
    </main-section> -->
  </div>
</template>
<script>
/* eslint-disable */
import { ref, reactive, watchEffect } from "vue";
import ViolationConsequencies from "@/views/humanresource/violationConsequencies/Index.vue";
export default {
  name: "ClassForm",
  components: {
    ViolationConsequencies,
  },
  props: {
    propObject: {
      type: Object,
      default: () => ({ empty: true }),
    },
  },
  data: function () {
    return {};
  },
  emits: ["close-modal", "submit"],
  setup(props, { emit }) {
    const titleStack = ref(["Admin", "Forms"]);

    const violation = reactive({});

    watchEffect(() => {
      const newClass = props.propObject;
      Object.assign(violation, newClass);
    });

    return {
      titleStack,
      violation,
    };
  },
};
</script>
